export const TABS = [
  { id: 1, label: 'Interval', value: 'interval' },
  { id: 2, label: 'Magic Lamp', value: 'magicLamp' },
  { id: 3, label: 'SkillX', value: 'skillX' },
];

export const PROJECT_REVENUE_MAPPER = [
  { id: 1, label: 'Foundation', value: '₹28,74,100' },
  { id: 2, label: 'Classroom', value: '₹10,14,100' },
  { id: 3, label: 'LG', value: '₹50,38,300' },
  { id: 4, label: 'Speak Pro', value: '₹80,84,100' },
];
export const RevenueExpenseDetailsTableHeader = [
  {
    field: 'courseName',
    headerName: 'Course Name',
    width: 250,
    toolTipGetter: true,
  },
  {
    field: 'total',
    headerName: 'Revenue',
    width: 180,
  },
  {
    field: 'enrollmentCount',
    headerName: 'Enrollments',
    width: 150,
  },
];
